import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    id: "user-account-profile-001",
    name: "Super Administrator",
    accountList: [
      {
        userName: "admin_hq",
        password: "P@ssw0rd!23",
        description: "Headquarters Administrator",
      },
      {
        userName: "netadmin",
        password: "N3t#2026!",
        description: "Network Operations",
      },
      {
        userName: "it_support",
        password: "SupP0rt@88",
        description: "",
      },
    ],
  },
  {
    id: "user-account-profile-002",
    name: "Network Administrator",
    accountList: [
      {
        userName: "guest_mgr",
        password: "Gu3st#WiFi",
        description: "Guest Wi-Fi Management",
      },
      {
        userName: "sec_admin",
        password: "S3cur3!Key",
        description: "",
      },
    ],
  },
  {
    id: "user-account-profile-003",
    name: "Security Operator",
    accountList: [
      {
        userName: "monitor01",
        password: "M0n!tor#45",
        description: "Surveillance Operator",
      },
      {
        userName: "auditor",
        password: "Audit#789",
        description: "",
      },
    ],
  },
];

const initialState = {
  resource: "userAccount",
  data: [...fakeData],
};

export const profileUserAccountSlice = createSlice({
  name: "profileUserAccount",
  initialState,
  reducers: {
    setUserAccountProfilesData: (state, _) => {
      state.data = [...fakeData];
    },
    createUserAccountProfile: (state, action) => {
      const newUserAccountProfile = {
        id: `user-account-profile-${(fakeData.length + 1).toString().padStart(3, "0")}`,
        name: action.payload.name,
        accountList: action.payload.accountList || [],
      };

      fakeData = [...fakeData, newUserAccountProfile];
      state.data = [...fakeData];
    },
    updateUserAccountProfile: (state, action) => {
      const profileId = action.payload.profileUserAccountsId || action.payload.id;
      const index = fakeData.findIndex(item => item.id === profileId);

      if (index !== -1) {
        fakeData[index] = {
          ...fakeData[index],
          ...action.payload,
          id: profileId,
        };
        state.data = [...fakeData];
      }
    },
    deleteUserAccountProfile: (state, action) => {
      const deleteIds = action.payload.profileUserAccountsIds || [];

      fakeData = fakeData.filter(item => !deleteIds.includes(item.id));
      state.data = [...fakeData];
    },
  },
});

export const {
  setUserAccountProfilesData,
  createUserAccountProfile,
  updateUserAccountProfile,
  deleteUserAccountProfile,
} = profileUserAccountSlice.actions;

export default profileUserAccountSlice.reducer;
